{
  "AUTOMATION": {
    "HEADER": "Automatizace",
    "DESCRIPTION": "Automatizace může nahradit a zjednodušit existující procesy, které vyžadují manuální úsilí, jako je přidávání štítků a přiřazování konverzací nejvhodnějšímu agentovi. To umožňuje týmu soustředit se na své silné stránky a zároveň snížit čas strávený rutinními úkoly.",
    "LEARN_MORE": "Další informace o automatizaci",
    "HEADER_BTN_TXT": "Přidat pravidlo",
    "LOADING": "Stahuji pravidla",
    "ADD": {
      "TITLE": "Přidat automatizační pravidlo",
      "SUBMIT": "Vytvořit",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "FORM": {
        "NAME": {
          "LABEL": "Název pravidla",
          "PLACEHOLDER": "Zadejte název pravidla",
          "ERROR": "Název je povinné pole"
        },
        "DESC": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadejte popis pravidla",
          "ERROR": "Popis je povinný"
        },
        "EVENT": {
          "LABEL": "Událost",
          "PLACEHOLDER": "Prosím vyberte jednu možnost",
          "ERROR": "Událost je povinná"
        },
        "PHASE": {
          "LABEL": "Fáze"
        },
        "ORDER": {
          "LABEL": "Pořadí",
          "ERROR": "Pořadí je povinné"
        },
        "CONDITIONS": {
          "LABEL": "Podmínky"
        },
        "ACTIONS": {
          "LABEL": "Akce"
        }
      },
      "CONDITION_BUTTON_LABEL": "Přidat podmínku",
      "ACTION_BUTTON_LABEL": "Přidat akci",
      "API": {
        "SUCCESS_MESSAGE": "Automatizační pravidlo bylo úspěšně přidáno",
        "ERROR_MESSAGE": "Nelze vytvořit automatizační pravidlo, zkuste to prosím později"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fáze",
        "ORDER": "Pořadí",
        "NAME": "Název",
        "DESCRIPTION": "Popis",
        "ACTIVE": "Aktivní",
        "CREATED_ON": "Vytvořeno dne",
        "WAIT": "Čekání"
      },
      "404": "Nenalezena žádná automatizační pravidla",
      "TABS": {
        "ALL": "Vše",
        "INSTANT": "Okamžitá",
        "DELAYED": "Se zpožděním"
      },
      "WAITS": "Čeká {duration}"
    },
    "DELETE": {
      "TITLE": "Smazat automatizační pravidlo",
      "SUBMIT": "Vymazat",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "CONFIRM": {
        "TITLE": "Potvrdit odstranění",
        "MESSAGE": "Opravdu chcete odstranit ",
        "YES": "Ano, odstranit ",
        "NO": "Ne, zachovat "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatizační pravidlo bylo úspěšně smazáno",
        "ERROR_MESSAGE": "Nelze smazat automatizační pravidlo, zkuste to prosím později"
      }
    },
    "EDIT": {
      "TITLE": "Upravit automatizační pravidlo",
      "SUBMIT": "Aktualizovat",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "API": {
        "SUCCESS_MESSAGE": "Automatizační pravidlo bylo úspěšně aktualizováno",
        "ERROR_MESSAGE": "Nelze aktualizovat automatizační pravidlo, zkuste to prosím později"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klonovat",
      "API": {
        "SUCCESS_MESSAGE": "Automatizace byla úspěšně naklonována",
        "ERROR_MESSAGE": "Nelze naklonovat automatizační pravidlo, zkuste to prosím později"
      }
    },
    "FORM": {
      "EDIT": "Upravit",
      "CREATE": "Vytvořit",
      "DELETE": "Vymazat",
      "CANCEL": "Zrušit",
      "RESET_MESSAGE": "Změna typu události resetuje podmínky a události, které jste přidali níže"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Musíte mít alespoň jednu podmínku pro uložení",
      "CONTACT_CUSTOM_ATTR_LABEL": "Vlastní atributy kontaktu",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Vlastní atributy konverzace"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Musíte mít alespoň jednu akci pro uložení",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Zadejte svou zprávu zde",
      "TEAM_DROPDOWN_PLACEHOLDER": "Vyberte týmy",
      "EMAIL_INPUT_PLACEHOLDER": "Zadejte e-mail",
      "URL_INPUT_PLACEHOLDER": "Zadejte URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Vyberte e-mailovou schránku a adresu odesílatele",
      "SUBJECT_INPUT_PLACEHOLDER": "Předmět e-mailu",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Vyberte SMS schránku, ze které se SMS odešle",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Zadejte text SMS",
      "SMS_COUNTER": "{length}/{limit} znaků, {segments} SMS (před doplněním proměnných)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktivovat automatizační pravidlo",
      "DEACTIVATION_TITLE": "Deaktivovat automatizační pravidlo",
      "ACTIVATION_DESCRIPTION": "Tato akce aktivuje automatizační pravidlo '{automationName}'. Opravdu chcete pokračovat?",
      "DEACTIVATION_DESCRIPTION": "Tato akce deaktivuje automatizační pravidlo '{automationName}'. Opravdu chcete pokračovat?",
      "ACTIVATION_SUCCESFUL": "Automatizační pravidlo úspěšně aktivováno",
      "DEACTIVATION_SUCCESFUL": "Automatizační pravidlo úspěšně deaktivováno",
      "ACTIVATION_ERROR": "Nelze aktivovat automatizaci, zkuste to prosím později",
      "DEACTIVATION_ERROR": "Nelze deaktivovat automatizaci, zkuste to prosím později",
      "CONFIRMATION_LABEL": "Ano",
      "CANCEL_LABEL": "Ne"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nelze nahrát přílohu, zkuste to prosím znovu",
      "LABEL_IDLE": "Nahrát přílohu",
      "LABEL_UPLOADING": "Nahrávání...",
      "LABEL_UPLOADED": "Úspěšně nahráno",
      "LABEL_UPLOAD_FAILED": "Nahrávání selhalo"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Klíč atributu je povinný",
      "FILTER_OPERATOR_REQUIRED": "Operátor filtru je povinný",
      "VALUE_REQUIRED": "Hodnota je povinná",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Hodnota musí být mezi 0 a 998",
      "ACTION_PARAMETERS_REQUIRED": "Parametry akce jsou povinné",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Je vyžadována alespoň jedna podmínka",
      "ATLEAST_ONE_ACTION_REQUIRED": "Je vyžadována alespoň jedna akce",
      "ORDER_REQUIRED": "Pořadí je povinné",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Pořadí musí být alespoň 1"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Tato akce funguje pouze pokud je fáze pravidla nastavena na 'Před štítkováním'.",
      "SKIP_AUTO_LABELING": "Tato akce funguje pouze pokud je fáze pravidla nastavena na 'Před štítkováním'.",
      "MOVE_CONVERSATION_TO_INBOX": "Do emailové schránky lze přesunout pouze emailové konverzace a konverzace z webového chatu, u chatu jen pokud má kontakt e-mailovou adresu. Jinak konverzace zůstane na místě a místo toho se přidá soukromá poznámka.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Založí s kontaktem novou konverzaci ve vybrané e-mailové schránce, pošle mu zprávu e-mailem a konverzaci označí jako vyřešenou. Stane se to pokaždé, když se pravidlo spustí. Pokud kontakt nemá e-mailovou adresu, nic se neodešle a místo toho se přidá soukromá poznámka.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Založí s kontaktem novou konverzaci ve vybrané SMS schránce, pošle mu zprávu jako SMS a konverzaci označí jako vyřešenou. Stane se to pokaždé, když se pravidlo spustí. Zpráva je prostý text bez příloh. Pokud kontakt nemá telefonní číslo, nic se neodešle a místo toho se přidá soukromá poznámka."
    },
    "NOTICES": {
      "AI_PROMPT": "Každé jednotlivé vyhodnocení je zpoplatněno.",
      "INCOMING_MESSAGES_COUNT": "Jedná se o počet příchozích zpráv v dané konverzaci.",
      "OUTGOING_MESSAGES_COUNT": "Jedná se o počet odchozích zpráv v dané konverzaci."
    },
    "PHASE": {
      "BEFORE_LABELING": "Před štítkováním",
      "AFTER_LABELING": "Po štítkování"
    },
    "NONE_OPTION": "Nic",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Příchozí zpráva",
      "OUTGOING": "Odchozí zpráva",
      "PRIVATE": "Privátní poznámka",
      "AI_SUMMARY": "AI sumarizace"
    },
    "YES_NO_VALUES": {
      "YES": "Ano",
      "NO": "Ne"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Přímá zpráva na Instagramu",
      "FACEBOOK_COMMENT": "Komentář na Facebooku"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Konverzace vytvořena",
      "CONVERSATION_UPDATED": "Konverzace aktualizována",
      "MESSAGE_CREATED": "Zpráva vytvořena",
      "CONVERSATION_OPENED": "Konverzace otevřena",
      "CONVERSATION_RESOLVED": "Konverzace vyřešena",
      "PHONE_CALL_FINISHED": "Hovor ukončen"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Přiřadit agenta",
      "ASSIGN_TEAM": "Přiřadit tým",
      "ADD_LABEL": "Přidat štítek",
      "REMOVE_LABEL": "Odebrat štítek",
      "SEND_EMAIL_TO_TEAM": "Poslat e-mail týmu",
      "SEND_EMAIL_TRANSCRIPT": "Poslat přepis e-mailem",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Poslat přepis e-mailem s podrobnostmi",
      "MUTE_CONVERSATION": "Umlčet konverzaci",
      "SNOOZE_CONVERSATION": "Odložit konverzaci",
      "RESOLVE_CONVERSATION": "Vyřešit konverzaci",
      "OPEN_CONVERSATION": "Otevřít konverzaci",
      "SEND_WEBHOOK_EVENT": "Zavolat webhook",
      "SEND_ATTACHMENT": "Odeslat přílohu",
      "SEND_MESSAGE": "Odeslat zprávu",
      "ADD_NOTE": "Přidat poznámku",
      "CHANGE_PRIORITY": "Změnit prioritu",
      "ADD_SLA": "Přidat SLA",
      "SKIP_AUTO_PRIORITY": "Přeskočit automatickou prioritu",
      "SKIP_AUTO_LABELING": "Přeskočit automatické štítkování",
      "AUTO_TRANSLATE": "Přeložit zprávu",
      "AUTO_TRANSLATE_CONVERSATION": "Přeložit konverzaci",
      "MOVE_CONVERSATION_TO_INBOX": "Přesunout konverzaci do schránky",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Odeslat zprávu v nové konverzaci",
      "SEND_SMS_IN_NEW_CONVERSATION": "Odeslat SMS v nové konverzaci",
      "STOP_PROCESSING_RULES": "Zastavit zpracování dalších pravidel"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI filtr",
      "MESSAGE_TYPE": "Typ zprávy",
      "MESSAGE_CONTAINS": "Obsah zprávy",
      "EMAIL": "E-mail kontaktu",
      "INBOX": "Schránka",
      "CHANNEL_TYPE": "Druh schránky",
      "CONVERSATION_LANGUAGE": "Jazyk konverzace",
      "PHONE_NUMBER": "Telefonní číslo",
      "STATUS": "Stav",
      "BROWSER_LANGUAGE": "Jazyk prohlížeče",
      "MAIL_SUBJECT": "Předmět e-mailu",
      "COUNTRY_NAME": "Země",
      "MARKETPLACE_COUNTRY": "Stát marketplace",
      "REFERER_LINK": "Přišel přes odkaz",
      "ASSIGNEE_NAME": "Přiřazený agent",
      "TEAM_NAME": "Přiřazený tým",
      "PRIORITY": "Priorita",
      "CALL_DIRECTION": "Druh hovoru",
      "MISSED_CALL": "Zmeškaný hovor",
      "MISSED_CALL_COUNT": "Počet zmeškaných hovorů",
      "MESSAGE_SOURCE_TYPE": "Zdroj zprávy",
      "INCOMING_MESSAGE_COUNT": "Počet příchozích zpráv",
      "OUTGOING_MESSAGE_COUNT": "Počet odchozích zpráv",
      "LABEL": "Štítek",
      "EMAIL_RECIPIENTS": "Příjemce emailu",
      "EMAIL_AUTO_REPLY": "E-mail je automatická odpověď",
      "ATTACHMENT_EXTENSION": "Přípona přílohy",
      "EXTENSION": "Volaná klapka",
      "WORKING_HOURS": "V pracovní době",
      "AGENT_REPLIED": "Agent odpověděl od změny stavu"
    },
    "WAIT": {
      "RUN_LABEL": "Spustit akce",
      "INSTANT": "Při události",
      "DELAYED": "S odkladem",
      "TRIGGER_LABEL": "Čekat, dokud",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Konverzace zůstává ve stavu",
        "CUSTOMER_UNRESPONSIVE": "Zákazník neodpovídá agentovi",
        "AGENT_UNRESPONSIVE": "Zákazník nedostal odpověď agenta"
      },
      "STATUS_LABEL": "Stav",
      "STATUSES": {
        "OPEN": "Otevřená",
        "PENDING": "Čekající",
        "SNOOZED": "Odložená",
        "RESOLVED": "Vyřešená"
      },
      "DELAY_LABEL": "Doba čekání",
      "DELAY_ERROR": "Zadejte dobu mezi 1 minutou a 30 dny",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Akce se spustí, když je konverzace ve stavu {status} po dobu {duration}. Změna stavu předtím je zruší. Štítky, pracovní dobu a odpovědi agentů kontrolujeme až na konci čekání.",
        "CUSTOMER_UNRESPONSIVE": "Akce se spustí, když zákazník {duration} neodpověděl na zprávu agenta. Odpověď zákazníka je zruší, nová zpráva agenta spustí čekání znovu.",
        "AGENT_UNRESPONSIVE": "Akce se spustí, když zákazník čeká {duration} bez odpovědi agenta. Odpověď agenta je zruší."
      }
    }
  }
}
